// extracted by mini-css-extract-plugin
module.exports = {"container":"SimplePagination_container__iY1zk","content":"SimplePagination_content__gTlnf","message":"SimplePagination_message__dQGr_","links":"SimplePagination_links__lOGEH"};